import React from 'react';
import { RefreshCw } from 'lucide-react';
import './UpdateNotification.css';

interface UpdateNotificationProps {
  onUpdate: () => void;
  version: string;
}

const UpdateNotification: React.FC<UpdateNotificationProps> = ({ onUpdate, version }) => {
  return (
    <div className="update-notification-overlay">
      <div className="update-notification-modal">
        <div className="update-notification-icon">
          <RefreshCw size={48} />
        </div>
        <h2>Nova versão disponível!</h2>
        <p>Uma nova versão ({version}) da aplicação está disponível.</p>
        <p className="update-notification-description">
          Clique em atualizar para obter as últimas melhorias e correções.
        </p>
        <button
          type="button"
          className="update-notification-button"
          onClick={onUpdate}
        >
          <RefreshCw size={18} />
          Atualizar agora
        </button>
      </div>
    </div>
  );
};

export default UpdateNotification;
